<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="hide-print flex p-8 flex-row antialiased text-gray-800">
      <loading :status="loading"></loading>
      <template v-if="isProcessing">
        <div class="flex-grow gap-2 md:flex">
          <div class="bg-white space-y-4 p-4 shadow rounded-md md:w-9/12">
            <div class="text-gray-700 md:flex justify-between">
              <div class="px-1 flex justify-between font-semibold">
                <p>{{ $t('Items') }} :</p>
                <p class="pl-2">{{ cartTotalItems }}</p>
              </div>
              <div class="px-1 flex justify-between font-semibold">
                <p>{{ $t('Discount') }}(-) :</p>
                <p class="pl-2">{{ order.discount | currency }}</p>
              </div>
              <div class="px-1 flex justify-between font-semibold">
                <template v-if="order.tax.is_tax_fix">
                  <p>{{ $t('Tax') }} ({{ order.tax.rate }} {{ $t('fix') }}) :</p>
                </template>
                <template v-else>
                  <p>{{ $t('Tax') }} ({{ order.tax.rate }}%) :</p>
                </template>
                <p class="pl-2">{{ taxAmount | currency }}</p>
              </div>
              <div class="px-1 flex justify-between font-semibold">
                <p>{{ $t('Shipping') }} (+):</p>
                <p class="pl-2">{{ order.shipping | currency }}</p>
              </div>
            </div>
            <div class="text-gray-700 md:flex justify-between">
              <div class="px-1 flex justify-between font-semibold">
                <p>{{ $t('Subtotal') }} :</p>
                <p class="pl-2">{{ cartTotalPrice | currency }}</p>
              </div>
              <div class="px-1 flex justify-between font-semibold">
                <p>{{ $t('Total') }} :</p>
                <p class="pl-2">{{ grandTotalAfterAll | currency }}</p>
              </div>
            </div>

            <div class="text-gray-700">
              <template v-if="moneys.length">
                <hr class="my-3" />
                <div class="grid grid-cols-4 gap-2 mt-2">
                  <template v-for="(money, index) in moneys">
                    <button @click.prevent="addRecepiantAmount(money)" class="btn btn-app">
                      + <span>{{ money | currency }}</span>
                    </button>
                  </template>
                </div>
              </template>
            </div>

            <div class="flex md:justify-between">
              <div class="col-span-3">
                <label class="form-label" for="discount_amout">{{ $t('Recipient amount') }}</label>
                <input type="number" step="0.01" v-model="recepientAmount" class="form-input" required />
              </div>
              <div class="col-span-3">
                <label class="form-label" for="discount_amout">{{ $t('Discount amount') }}</label>
                <input type="number" :placeholder="$t('Discount amount')" v-model="order.discount" id="discount_amout" class="form-input" required />
              </div>
              <div class="col-span-3">
                <label class="form-label" for="shipping">{{ $t('Shipping amount') }}</label>
                <input type="number" :placeholder="$t('Shipping amount')" v-model="order.shipping" id="shipping" class="form-input" required />
              </div>
            </div>
            <div v-if="changeAmount > 0" class="text-gray-700 shadow p-4 rounded-md bg-red-50 flex">
              <div class="form-label">{{ $t('CHANGE') }}</div>
              <div class="text-right flex-grow">{{ changeAmount | currency }}</div>
            </div>
            <div class="col-span-3">
              <label class="form-label" for="note">{{ $t('Sale note') }}</label>
              <textarea v-model="order.note" id="note" class="form-input w-full" rows="2"></textarea>
            </div>
            <div class="md:flex md:space-x-2 w-full">
              <button @click.prevent="isProcessing = false" class="w-full h-14 px-6 btn btn-yellow">
                {{ 'Cancel' }}
              </button>
              <button @click.prevent="submitSaleOrder" class="w-full h-14 px-6 btn btn-green">
                {{ $t('Process') }}
              </button>
            </div>
          </div>
          <div class="bg-white space-y-4 shadow rounded-md p-6 md:w-3/12">
            <div class="grid grid-cols-1 text-gray-700">
              <div class="col-span-3">
                <label class="form-label" for="tax_id">{{ $t('Tax ID') }}</label>
                <input type="text" :placeholder="$t('Tax ID')" v-model="order.tax.tax_id" id="tax_id" class="form-input" required />
              </div>
              <div class="col-span-3 mt-2">
                <label class="form-label" for="rate">{{ $t('Tax rate') }}</label>
                <input type="number" :placeholder="$t('Tax rate')" v-model="order.tax.tax_rate" id="rate" class="form-input" required />
              </div>
              <div class="col-span-3 mt-2">
                <label class="form-label" for="is_vat">{{ $t('is vat') }}</label>
                <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="is_vat" v-model="order.tax.is_vat"></input-switch>
                <div class="form-description-text">{{ $t('This will control Vat implementation while calculation') }}.</div>
              </div>
              <div class="col-span-3 mt-2">
                <label class="form-label" for="is_tax_included">{{ $t('Is tax included') }}</label>
                <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="is_tax_included" v-model="order.tax.is_tax_included"></input-switch>
                <div class="form-description-text">{{ $t('This will control how tax can be add to total amount') }}.</div>
              </div>
              <div v-if="!order.tax.is_vat" class="col-span-3 mt-2">
                <label class="form-label" for="is_tax_fix">{{ $t('Is fix or percentage') }}</label>
                <input-switch :disabled-label="$t('Disabled')" :enabled-label="$t('Enabled')" id="is_tax_fix" v-model="order.tax.is_tax_fix"></input-switch>
                <div class="form-description-text">{{ $t('This will control tax implementation could be percentage or fixed') }}.</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- POS content -->
        <div class="flex-grow flex min-h-screen">
          <div class="px-2 md:flex flex-col h-full w-full">
            <div class="flex flex-row relative">
              <loading :status="isScanning"></loading>
              <div class="absolute flex rounded-none rounded-l-md">
                <button class="btn shadow-none p-2" @click.prevent="searchModel = true">
                  <svg-vue class="h-6" icon="font-awesome.search-solid"></svg-vue>
                </button>
                <button
                  :class="posSetup.pos_scanner_focus_autofocus ? 'text-green-700' : 'text-gray-700'"
                  class="btn shadow-none p-2 rounded-none"
                  @click="posSetup.pos_scanner_focus_autofocus = !posSetup.pos_scanner_focus_autofocus"
                >
                  <svg-vue class="h-6" icon="font-awesome.barcode"></svg-vue>
                </button>
              </div>
              <input id="search-input" v-model="barcode" type="text" class="shadow-lg form-input pl-24" autofocus />
            </div>

            <div class="h-full overflow-hidden mt-2">
              <div class="h-full overflow-y-auto px-2">
                <ol class="flex text-gray-700 py-2 px-2 rounded-lg bg-white shadow hover:shadow-lg">
                  <li class="px-2 bg-gray-200 rounded-md mr-1 cursor-pointer" @click="displayCategories">
                    {{ $t('All categories') }}
                  </li>
                  <template v-if="breadcrumb.category">
                    <li class="px-2 rounded-md bg-gray-200 cursor-pointer mr-1" @click="displayProducts">
                      {{ breadcrumb.category }}
                    </li>
                  </template>
                  <template class="breadcrumb.product">
                    <li class="px-2">
                      {{ breadcrumb.product | capitalize }}
                    </li>
                  </template>
                  <template v-if="breadcrumb.variants > 0">
                    <li class="px-2">{{ breadcrumb.variants }}</li>
                  </template>
                </ol>
                <template v-if="categoriesListing">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 py-2">
                    <div
                      v-for="(category, index) in categories"
                      :key="index"
                      role="button"
                      class="p-1 border-t border-yellow-400 select-none cursor-pointer transition-shadow overflow-hidden rounded-lg bg-white shadow hover:shadow-lg"
                      :title="category.name"
                      @click="filterCategory(category)"
                    >
                      <img class="mx-auto h-32 w-32 my-1 rounded-md" :src="category.image" :alt="category.name" />
                      <div class="flex px-2 text-center">
                        <p class="flex-grow text-gray-700 text-xs truncate">{{ category.name }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="w-ful my-4 p-2 flex justify-between">
                    <p class="text-sm leading-5 text-gray-700 pt-3">
                      {{ $t('Showing') }}
                      <span class="font-medium">
                        {{ categoryPagination.perPage * categoryPagination.currentPage - categoryPagination.perPage + 1 }}
                      </span>
                      {{ $t('to') }}
                      <span class="font-medium">
                        {{
                          categoryPagination.perPage * categoryPagination.currentPage <= categoryPagination.total
                            ? categoryPagination.perPage * categoryPagination.currentPage
                            : categoryPagination.total
                        }}
                      </span>
                      {{ $t('of') }}
                      <span class="font-medium">{{ categoryPagination.total }}</span>
                      {{ $t('results') }}
                    </p>
                    <div class="flex-1 flex justify-between sm:justify-end">
                      <button
                        :class="categoryPagination.currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="categoryPagination.currentPage <= 1"
                        @click.prevent="changeCategoryPage(categoryPagination.currentPage - 1)"
                        class="pagination-link"
                        type="button"
                      >
                        {{ $t('Previous') }}
                      </button>
                      <button
                        :class="categoryPagination.currentPage >= categoryPagination.totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="categoryPagination.currentPage >= categoryPagination.totalPages"
                        @click.prevent="changeCategoryPage(categoryPagination.currentPage + 1)"
                        class="ml-3 pagination-link"
                        type="button"
                      >
                        {{ $t('Next') }}
                      </button>
                    </div>
                  </div>
                </template>
                <template v-if="productsListing">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 py-2">
                    <div
                      v-for="(product, index) in products"
                      :key="index"
                      role="button"
                      class="p-1 border-t border-green-400 select-none cursor-pointer transition-shadow overflow-hidden rounded-lg bg-white shadow hover:shadow-lg"
                      :title="product.name"
                      @click="addToCart(product)"
                    >
                      <div class="flex justify-between items-center px-2">
                        <template v-if="product.has_variants">
                          <div class="text-gray-800 text-sm">
                            <svg-vue class="content-title-icon" icon="font-awesome.sitemap-solid"></svg-vue>
                          </div>
                          <div>
                            <span class="font-medium">{{ product.variants.length }}</span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="text-gray-800 text-md">
                            <span class="font-medium">{{ product.price | currency }}</span>
                          </div>
                          <div>
                            <span class="text-green-500 rounded-md bg-green-200 px-2 py-1 text-xs select-none" v-if="product.in_stock">
                              {{ product.in_stock }}
                            </span>
                            <span class="text-red-500 rounded-md bg-red-200 px-2 py-1 text-xs select-none" v-else>
                              {{ $t('Out') }}
                            </span>
                          </div>
                        </template>
                      </div>
                      <img class="mx-auto h-32 w-32 my-2 rounded-md" :src="product.image" :alt="product.name" />
                      <div class="flex px-2 text-center">
                        <p class="flex-grow font-medium text-gray-700 text-xs truncate">
                          {{ product.name | capitalize }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="w-ful my-4 p-2 flex justify-between">
                    <p class="text-sm leading-5 text-gray-700 pt-3">
                      {{ $t('Showing') }}
                      <span class="font-medium">
                        {{ productPagination.perPage * productPagination.currentPage - productPagination.perPage + 1 }}
                      </span>
                      {{ $t('to') }}
                      <span class="font-medium">
                        {{
                          productPagination.perPage * productPagination.currentPage <= productPagination.total
                            ? productPagination.perPage * productPagination.currentPage
                            : productPagination.total
                        }}
                      </span>
                      {{ $t('of') }}
                      <span class="font-medium">{{ productPagination.total }}</span>
                      {{ $t('results') }}
                    </p>
                    <div class="flex-1 flex justify-between sm:justify-end">
                      <button
                        :class="productPagination.currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="productPagination.currentPage <= 1"
                        @click.prevent="changeProductPage(productPagination.currentPage - 1)"
                        class="pagination-link"
                        type="button"
                      >
                        {{ $t('Previous') }}
                      </button>
                      <button
                        :class="productPagination.currentPage >= productPagination.totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="productPagination.currentPage >= productPagination.totalPages"
                        @click.prevent="changeProductPage(productPagination.currentPage + 1)"
                        class="ml-3 pagination-link"
                        type="button"
                      >
                        {{ $t('Next') }}
                      </button>
                    </div>
                  </div>
                </template>
                <template v-if="variantsListing">
                  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 py-2">
                    <div
                      v-for="(variant, index) in variants"
                      :key="index"
                      role="button"
                      class="p-1 border-t border-blue-400 select-none cursor-pointer transition-shadow overflow-hidden rounded-lg bg-white shadow hover:shadow-lg"
                      :title="variant.name"
                      @click="addToCart(variant)"
                    >
                      <div class="flex justify-between items-center px-2">
                        <div class="text-gray-800 text-md">
                          <span class="font-medium">{{ variant.price | currency }}</span>
                        </div>
                        <div>
                          <span class="text-blue-500 rounded-md bg-blue-200 px-2 py-1 text-xs select-none" v-if="variant.in_stock">
                            {{ variant.in_stock }}
                          </span>
                          <span class="text-red-500 rounded-md bg-red-200 px-2 py-1 text-xs select-none" v-else>
                            {{ $t('Out') }}
                          </span>
                        </div>
                      </div>
                      <img class="mx-auto h-32 w-32 my-2 rounded-md" :src="variant.image" :alt="variant.name" />
                      <div class="flex px-2">
                        <p class="flex-grow font-medium text-gray-700 text-xs truncate">
                          {{ variant.title | capitalize }}
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-if="nothingFound">
                  <div class="select-none bg-blue-gray-100 rounded flex flex-wrap content-center justify-center pt-24 opacity-25">
                    <div class="w-full text-center">
                      <svg-vue class="h-24 w-24 inline-block" icon="font-awesome.exclamation-triangle-duotone"></svg-vue>
                      <p class="text-xl">
                        {{ $t('Items not found') }}
                      </p>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <!-- right cart area -->
          <div class="w-5/12 flex flex-col">
            <div class="bg-white rounded-lg flex flex-col h-5/6 shadow">
              <!-- empty cart -->
              <div v-if="cartTotalItems === 0" class="flex-1 w-full p-4 opacity-25 select-none flex flex-col flex-wrap content-center justify-center">
                <svg-vue class="h-16 inline-block" icon="font-awesome.cart-arrow-down-solid"></svg-vue>
                <p>
                  {{ $t('Cart empty') }}
                </p>
              </div>

              <!-- cart items -->
              <div v-if="cartTotalItems > 0" class="flex-1 flex flex-col overflow-auto">
                <div class="h-16 text-center flex justify-center">
                  <div class="pl-8 text-left text-lg py-4 relative">
                    <!-- cart icon -->
                    <svg-vue class="h-8 w-8 inline-block" icon="font-awesome.shopping-cart-solid"></svg-vue>
                    <div v-if="cartTotalItems > 0" class="text-center absolute bg-yellow-400 text-white w-5 h-5 text-xs p-0 leading-5 rounded-full -right-2 top-3">
                      {{ cartTotalItems }}
                    </div>
                  </div>
                  <div class="flex-grow px-8 text-right text-lg py-4 relative">
                    <!-- trash button -->
                    <button @click="unsetCartItems" class="text-gray-400 hover:text-red-500 focus:outline-none">
                      <svg-vue class="h-6 w-6 inline-block" icon="font-awesome.trash-alt-regular"></svg-vue>
                    </button>
                  </div>
                </div>

                <div class="flex-1 w-full px-4 overflow-auto">
                  <div class="flow-root">
                    <ul role="list" class="-my-6 divide-y divide-gray-300 pt-4">
                      <li v-for="(item, index) in cartItems" :key="index" class="py-3 flex">
                        <div class="flex-shrink-0 w-24 h-24 border border-gray-200 rounded-md overflow-hidden">
                          <img :src="item.image" :alt="item.name" class="w-full h-full object-center object-cover" />
                        </div>

                        <div class="ml-4 flex-1 flex flex-col">
                          <div>
                            <div class="flex justify-between text-xs font-medium text-gray-900">
                              <div>
                                <h3>
                                  {{ item.name }}
                                </h3>
                                <p class="text-xs text-gray-500" v-if="item.title">{{ item.title | capitalize }}</p>
                                <p class="text-xs text-gray-500 text-xs" v-if="item.serial_number">{{ $t('SN') }}: {{ item.serial_number | capitalize }}</p>
                                <p class="text-xs text-gray-500 text-xs" v-if="item.identity">{{ $t('ID') }}: {{ item.identity | capitalize }}</p>
                              </div>
                              <p class="ml-4 text-xs text-gray-600">
                                <small>{{ item.price | currency }}</small>
                                <br />{{ item.sub_total | currency }}
                              </p>
                            </div>
                          </div>
                          <div class="flex-1 flex items-end justify-between text-xs">
                            <div class="flex text-lg border border-gray-200 text-gray-600 rounded-md bg-gray-100">
                              <button :disabled="item.qty < 2" @click.prevent="itemQtyChange(item, false)" class="w-10 border-none px-2 text-center">-</button>
                              <input disabled class="w-10 border-none px-2 text-center" v-model="item.qty" />
                              <button :disabled="item.qty == item.in_stock" @click.prevent="itemQtyChange(item, true)" class="w-10 border-none px-2 text-center">
                                +
                              </button>
                            </div>
                            <button type="button" @click.prevent="editCartItem(item)" class="font-medium text-blue-600 hover:text-blue-500">
                              {{ $t('Edit') }}
                            </button>
                            <button type="button" @click.prevent="unsetCartItem(item)" class="font-medium text-red-600 hover:text-red-500">
                              {{ $t('Remove') }}
                            </button>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <!-- end of cart items -->

              <!-- payment info -->
              <div class="select-none h-auto w-full text-center pt-3 pb-4 px-4">
                <div class="mt-2">
                  <button class="btn btn-app rounded-none rounded-l-md" @click.prevent="$router.push('/')">
                    {{ 'Back' }}
                  </button>
                  <button class="btn btn-app rounded-none" @click="clearCartItems">{{ 'Clear' }}</button>
                  <button :disabled="cartItems.length < 1" class="btn btn-app rounded-none rounded-r-md" @click.prevent="isProcessing = true">
                    {{ 'Next' }}
                  </button>
                </div>
              </div>
              <!-- end of payment info -->
            </div>
          </div>
          <!-- end of right cart area -->
        </div>
        <!-- end POS content -->
      </template>

      <!-- search model start -->
      <search-model :show="searchModel" @close="closeSearch">
        <div class="flex-auto overflow-hidden flex flex-col">
          <loading :status="isSearching" />
          <div class="p-2 border-b border-gray-300">
            <div class="flex border-blue-400 border-2 rounded overflow-hidden">
              <input @keyup.enter="search" v-model="searchValue" ref="searchField" type="text" class="p-2 outline-none flex-auto text-gray-700 bg-blue-100" />
              <button @click="search" class="px-2 bg-blue-400 text-white">{{ $t('Search') }}</button>
            </div>
          </div>
          <div class="overflow-y-auto flex-auto relative">
            <ul>
              <li
                v-for="item of searchedProducts"
                :key="item.id"
                @click="addToCart(item)"
                v-if="!item.has_variants"
                class="hover:bg-blue-100 cursor-pointer p-2 flex justify-between border-b"
              >
                <div class="flex-shrink-0 w-15 h-15 border border-gray-200 rounded-md overflow-hidden">
                  <img :src="item.image" :alt="item.name" class="w-full h-full object-center object-cover" />
                </div>
                <div class="ml-4 flex-1 flex flex-col">
                  <div class="text-xs flex justify-between font-medium text-gray-900">
                    <div>
                      <h3>{{ item.name }}</h3>
                      <h3 class="text-gray-500 mt-2">{{ $t('UPC') }}: {{ item.upc }}</h3>
                      <h4 class="text-gray-500">{{ $t('In stock') }}: {{ item.in_stock }}</h4>
                    </div>
                    <small>{{ item.price | currency }}</small>
                  </div>
                </div>
              </li>
              <li
                v-else
                v-for="(variant, index) in item.variants"
                :key="index"
                @click="addToCart(variant)"
                class="hover:bg-blue-100 cursor-pointer p-2 flex justify-between border-b"
              >
                <div class="flex-shrink-0 w-15 h-15 border border-gray-200 rounded-md overflow-hidden">
                  <img :src="variant.image" :alt="variant.name" class="w-full h-full object-center object-cover" />
                </div>
                <div class="ml-4 flex-1 flex flex-col">
                  <div class="flex justify-between text-xs font-medium text-gray-900">
                    <div>
                      <h3>{{ variant.name | capitalize }}({{ variant.title | capitalize }})</h3>
                      <h3 class="text-gray-500 mt-2">{{ $t('UPC') }}: {{ variant.upc }}</h3>
                      <h4 class="text-gray-500">{{ $t('In stock') }}: {{ variant.in_stock }}</h4>
                    </div>
                    <small>{{ variant.price | currency }}</small>
                  </div>
                </div>
              </li>
              <li v-if="searchedProducts.length === 0" class="text-gray-700 text-center p-2">
                {{ $t('There is nothing to display. Have you started the search ?') }}
              </li>
            </ul>
          </div>
        </div>
      </search-model>
      <!-- search model -->
      <cart-item-edit :show="isEdittingCartItem" @close="isEdittingCartItem = false">
        <div class="grid grid-cols-3 gap-6">
          <div class="col-span-3">
            <label class="input-label" for="name">
              {{ $t('Item name') }}
            </label>
            <input :placeholder="$t('Item name')" class="form-input mt-1" id="name" required type="text" v-model="edittedCartItem.name" />
          </div>
          <div v-if="edittedCartItem.title" class="col-span-3">
            <label class="input-label" for="title">
              {{ $t('Item variant') }}
            </label>
            <input :placeholder="$t('Item variant')" class="form-input mt-1" id="title" required type="text" v-model="edittedCartItem.title" />
          </div>
          <div class="col-span-3">
            <label class="input-label" for="price">
              {{ $t('Item price') }}
            </label>
            <input :placeholder="$t('Item price')" class="form-input mt-1" id="price" required type="number" v-model="edittedCartItem.price" />
          </div>
          <div class="col-span-3">
            <label class="input-label" for="qty">
              {{ $t('Item QTY') }}
            </label>
            <input :placeholder="$t('Item qty')" class="form-input mt-1" id="qty" required type="number" v-model="edittedCartItem.qty" />
          </div>
          <div class="col-span-3">
            <label class="input-label" for="serial_number">
              {{ $t('Serial number') }}
            </label>
            <input :placeholder="$t('Serial number')" class="form-input mt-1" id="serial_number" required type="text" v-model="edittedCartItem.serial_number" />
          </div>
          <div class="col-span-3">
            <label class="input-label" for="identity">
              {{ $t('Identity') }}
            </label>
            <input :placeholder="$t('Identity')" class="form-input mt-1" id="identity" required type="text" v-model="edittedCartItem.identity" />
          </div>
          <button class="btn btn-app w-full" @click.prevent="cartItemInfoEditUpdate">{{ $t('Update') }}</button>
        </div>
      </cart-item-edit>
    </div>
  </main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { pickBy, identity } from 'lodash';
import model from '@/components/model';

export default {
  name: 'pos',
  metaInfo() {
    return {
      title: this.$i18n.t('Point of sale'),
    };
  },
  components: { 'search-model': model, 'cart-item-edit': model },
  data() {
    return {
      productPagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
        page: 0,
      },
      categoryPagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
        page: 0,
      },
      isProcessing: false,
      loading: false,
      submitable: false,
      editTax: false,
      setDiscount: false,
      actionsSidebar: false,
      autoFocus: false,
      searchValue: null,
      isSearching: false,
      isScanning: false,
      searchModel: false,
      isEdittingCartItem: false,
      edittedCartItem: {},
      searchedProducts: [],
      barcode: null,
      keyword: '',
      recepientAmount: 0,
      categories: [],
      filters: {
        category: null,
      },
      posSetup: {
        pos_monies: '100,500,1000,5000',
        pos_scanner_focus_autofocus: false,
        pos_scanner_focus_duration: 5000,
        pos_scanner_processing_delay: 1500,
      },
      products: [],
      variants: [],
      breadcrumb: {
        category: null,
        product: null,
        variants: 0,
      },
      order: {
        discount: 0,
        shipping: 0,
        note: null,
        tax: {
          is_vat: false,
          rate: 0,
          tax_id: null,
          is_tax_included: false,
          is_tax_fix: false,
        },
      },
    };
  },
  watch: {
    barcode() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.scanBarcode(this.barcode);
      }, Number(this.posSetup.pos_scanner_processing_delay));
    },
  },
  computed: {
    ...mapGetters({
      cartItems: 'cart/getCartItems',
      cartTotalItems: 'cart/getCartTotalItems',
      cartTotalPrice: 'cart/getCartTotalPrice',
      cartTotalCost: 'cart/getCartTotalCost',
    }),

    moneys() {
      if (this.posSetup.pos_monies == 0) {
        return [];
      }
      return this.posSetup.pos_monies.split(',');
    },
    anyFilter() {
      return pickBy(this.filters, identity);
    },
    nothingFound() {
      return !this.variantsListing && !this.productsListing && !this.categoriesListing;
    },
    variantsListing() {
      return this.products.length && this.variants.length && this.breadcrumb.category && this.breadcrumb.product;
    },
    productsListing() {
      return this.variants.length < 1 && this.products.length && this.breadcrumb.category;
    },
    categoriesListing() {
      return this.categories.length && !this.breadcrumb.category;
    },
    taxAmount() {
      const amount = this.cartTotalPrice;
      if (this.order.tax.is_vat) {
        let rating = '1.' + this.order.tax.tax_rate ?? this.order.tax.rate;
        if (this.order.tax.is_tax_included) {
          return Number(amount - Number(amount / rating));
        } else {
          return Number(Number(amount * rating) - amount);
        }
      } else {
        const rate = Number(this.order.tax.tax_rate ?? this.order.tax.rate);
        if (this.order.tax.is_tax_fix) {
          return rate;
        }
        return amount * (rate / 100);
      }
    },
    grandTotalAfterAll() {
      let afterDiscount = Number(this.cartTotalPrice) - Number(this.order.discount);
      let withShipping = Number(afterDiscount) + Number(this.order.shipping);
      if (this.order.tax.is_tax_included) {
        return Number(withShipping);
      }
      return Number(withShipping + this.taxAmount);
    },
    changeAmount() {
      return this.recepientAmount - this.grandTotalAfterAll;
    },
    somthingeUnderProcess() {
      return this.searchModel || this.isProcessing || this.loading || this.isSearching || this.isEdittingCartItem;
    },
  },
  mounted() {
    this.loadAll();
    setInterval(() => this.setFocus(), this.posSetup.pos_scanner_focus_duration);
  },
  methods: {
    ...mapActions({
      setCartItems: 'cart/setCartItems',
      unsetCartItems: 'cart/unsetCartItems',
      setCartItem: 'cart/setCartItem',
      unsetCartItem: 'cart/unsetCartItem',
      updateCartItem: 'cart/updateCartItem',
    }),

    changeCategoryPage(page) {
      if (page > 0 && page <= this.categoryPagination.totalPages && page !== this.categoryPagination.page) {
        this.categoryPagination.page = page;
        this.getPosCategories();
      }
    },
    changeProductPage(page) {
      if (page > 0 && page <= this.productPagination.totalPages && page !== this.productPagination.page) {
        this.productPagination.page = page;
        this.getPosProducts();
      }
    },
    cartItemInfoEditUpdate() {
      this.updateCartItem(this.edittedCartItem);
      this.isEdittingCartItem = false;
    },

    getPOSSetup() {
      this.loading = false;
      axios
        .get(route('settings.get.pos-config'))
        .then((response) => {
          this.posSetup = response.data;
          this.loading = false;
        })
        .catch(function () {
          this.loading = false;
          console.log('error');
        });
    },
    editCartItem(item) {
      this.isEdittingCartItem = true;
      this.edittedCartItem = item;
    },
    setFocus() {
      if (!this.somthingeUnderProcess) {
        const el = document.getElementById('search-input');
        if (el && this.posSetup.pos_scanner_focus_autofocus) {
          el.focus();
        }
      }
    },
    closeSearch() {
      this.searchModel = false;
      this.searchValue = null;
      this.searchedProducts = [];
    },
    barcodeProcessing(value) {
      this.isScanning = true;
      axios
        .post(route('scan-barcode'), { barcode: value })
        .then((response) => {
          if (response.data.message) {
            this.isScanning = false;
            this.$notify({
              title: this.$i18n.t('Warning').toString(),
              text: response.data.message.toString(),
              type: 'warning',
            });
          } else {
            this.isScanning = false;
            this.barcode = null;
            this.pushToCart(response.data);
          }
        })
        .catch((error) => {
          this.isScanning = false;
          console.log('error');
        });
    },
    scanBarcode() {
      if (this.barcode) {
        setTimeout(() => {
          this.barcodeProcessing(this.barcode);
        }, Number(this.posSetup.pos_scanner_processing_delay));
      }
    },
    submitSaleOrder() {
      this.loading = true;
      this.order.items = this.cartItems;
      this.order.cart_total_items = this.cartTotalItems;
      this.order.cart_total_price = this.cartTotalPrice;
      this.order.cart_total_cost = this.cartTotalCost;
      this.order.cart_total_profit = Number(this.cartTotalPrice - this.cartTotalCost);
      this.order.tax_amount = this.taxAmount;
      this.order.payable_after_all = this.grandTotalAfterAll;
      this.order.profit_after_all = Number(this.grandTotalAfterAll - this.cartTotalCost);
      this.order.recepient_amount = this.recepientAmount;
      this.order.change_amount = this.changeAmount;
      axios
        .post(route('sale-orders.store'), this.order)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.clearCartItems();
          this.$router.push('/print/sale-order/' + response.data.sale);
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    clearCartItems() {
      this.recepientAmount = 0;
      this.unsetCartItems();
    },
    addRecepiantAmount(amount) {
      this.recepientAmount = Number(this.recepientAmount) + Number(amount);
    },
    itemQtyChange(item, addtion) {
      addtion ? item.qty++ : item.qty--;
      this.updateCartItem(item);
    },

    loadAll() {
      this.getPOSSetup();
      this.breadcrumbReset();
      this.getPosProducts();
      this.getPosCategories();
      this.order.tax = this.$store.getters['app/getTaxSetup'];
    },
    displayProducts() {
      this.variants = [];
      this.breadcrumb.product = null;
      this.breadcrumb.variants = null;
      this.getPosProducts();
    },
    displayCategories() {
      this.breadcrumbReset();
      this.getPosCategories();
    },
    filterCategory(category) {
      this.breadcrumbReset();
      this.filters.category = category.id;
      this.breadcrumb.category = category.name;
      this.getPosProducts();
    },
    breadcrumbReset() {
      this.variants = [];
      this.breadcrumb = { category: null, product: null, variants: 0 };
    },

    getPosCategories() {
      this.loading = true;
      axios
        .get(route('pos.categories'), { params: this.categoryPagination })
        .then((response) => {
          this.categories = response.data.categories;
          this.categoryPagination = response.data.pagination;
          if (this.categoryPagination.totalPages < this.categoryPagination.currentPage) {
            this.categoryPagination.page = this.categoryPagination.totalPages;
            this.getPosCategories();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    search() {
      this.isSearching = true;
      if (this.searchValue) {
        axios
          .post(route('search-products'), { search: this.searchValue })
          .then((response) => {
            this.isSearching = false;
            this.searchedProducts = response.data;
          })
          .catch((error) => {
            this.isSearching = false;
          });
      } else {
        this.isSearching = false;
        this.$notify({
          title: this.$i18n.t('Warning').toString(),
          text: this.$i18n.t('Please enter something to process search').toString(),
          type: 'warning',
        });
      }
    },
    pushToCart(product) {
      if (product.in_stock > 0) {
        this.setCartItem(product);
      } else {
        this.flashUpOutOfStock();
      }
    },
    flashUpOutOfStock() {
      this.$notify({
        title: this.$i18n.t('Warning').toString(),
        text: this.$i18n.t('This item is out of stock').toString(),
        type: 'warning',
      });
    },
    addToCart(product) {
      if (product.has_variants) {
        this.breadcrumb.product = product.name;
        this.breadcrumb.variants = product.variants.length;
        this.variants = product.variants;
      } else {
        this.pushToCart(product);
      }
    },
    getPosProducts() {
      this.loading = true;
      let parameters = {
        page: this.productPagination.page,
        perPage: this.productPagination.perPage,
        ...this.filters,
      };
      axios
        .get(route('pos.products'), { params: parameters })
        .then((response) => {
          this.products = response.data.products;
          this.productPagination = response.data.pagination;
          if (this.productPagination.totalPages < this.productPagination.currentPage) {
            this.productPagination.page = this.productPagination.totalPages;
            this.getPosProducts();
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
